module.exports = __webpack_public_path__ + "static/media/bg1.9cb9bd6a.jpg";